import { Component } from 'src/utils';
import logoIcon from './../../../images/small-logo.png';
import houseIcon from './../../../images/house-icon.png';
import template from './address.html';

@Component({
  controllerAs: 'address',
  template
})

export default class DeliveryAddress {
  static $inject = [
    '$scope',
    '$rootScope',
    '$ngRedux',
    '$state',
    'spinnerService',
    'authService',
    'APP', '$window', '$stateParams',
    'toaster',
    '$uibModal'
  ];

  constructor($scope, $rootScope, $ngRedux, $state, $spinner, $auth, APP, $window, $stateParams,$toaster,$uibModal) {
    const disconnect = $ngRedux.connect(this.mapState)(this);

    this.$rootScope = $rootScope;
    this.$auth = $auth;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$toaster=$toaster;
    this.$window = $window;
    this.$uibModal = $uibModal;
    this.APP = APP;
    this.logoIcon = logoIcon;
    this.houseIcon = houseIcon;
    this.temp = {};
    this.$spinner = $spinner;
    this.$rootScope.deliveryMode = 'Next Day Delivery';
    this.isSubscriptionAddressChage = false;
    this.saveAddressToProfile = false;
    var subScribedInfo = this.$auth.getSubscribedInfo();
    if (subScribedInfo && subScribedInfo.addressChange){
      this.isSubscriptionAddressChage = true;
    }
  
   
    this.$spinner.show('appSpinner');
 
    var $ctrl;
    $ctrl = this;
    $auth.getUserProfile().then(success => {
        let addressObj = localStorage.getItem('deliveryAddress');
        this.shippingAddressTempSolution = JSON.parse(JSON.stringify(this.profile));
        $ctrl.temp = addressObj ? JSON.parse(addressObj) : success.data;
         if(!$ctrl.temp.firstName || $ctrl.temp.firstName === undefined){
          $ctrl.temp.firstName = $ctrl.temp.customer.firstName;
          $ctrl.temp.lastName = $ctrl.temp.customer.lastName;
         }
        
      })
      .finally(() => { this.$spinner.hide('appSpinner');
      $auth.getCountries().then(success => {
        // console.log(success);
        this.getStates(this.profile.shippingCountry.countryCode,"shippingAddress",0);
      });
    });
    $scope.$on('$destroy', disconnect);
  }

  goToHomePage() {
    let storeName = '';
    if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
      storeName = this.$stateParams.storeName;
    } else {
      if (this.profile.store && this.profile.store.storeName) {
        storeName = this.profile.store.storeURLName;
      } else {
        storeName = this.$auth.getGuestStoreDetail().storeName;
      }
    }
    if (storeName) {
      this.$window.location.href = '/' + storeName;
    } else {
      this.$state.go('home');

    }
  }

  mapState(state) {
    return {
       profile: state.auth.profile,
       shippingCountries: state.auth.countries,
       billingCountries: state.auth.countries
    };
  }
  getStates(country, type ,time) {
    // console.log(country);
    // console.log(type);
    switch (type) {
      case 'billingAddress':
        if (this.profile && time !== 0) {
          if (this.profile.billingState) {
            this.profile.billingState.code = '';
            this.profile.billingZipCode = '';
          }
        }
        var billingStates = '';
        // console.log(this.billingCountries);
        angular.forEach(this.billingCountries, function(value) {
         
          
          if (country === value.label) {
            billingStates = value.states;
          }
        });

        this.billingStates = billingStates;
        break;
      case 'shippingAddress':
      if (this.profile && time !== 0) {
        if (this.profile.shippingState) {
          this.profile.shippingState.code = '';
          this.profile.shippingZipCode = '';
        }
      }
      var shippingStates = '';
      // console.log(this.shippingCountries);
      angular.forEach(this.shippingCountries, function(value) {
        // console.log(country,"==",value.label);
        if (country === value.label) {
          shippingStates = value.states;
        }
      });
      
      this.shippingStates = shippingStates;
        break;
      default: 
        break;

    }
 

  }
  submit(form) {
    if (form.$invalid) {
      return;
    }
    let userDetail = {};
    var country = '';
    var state = '';
    var profile= this.temp;
    var $ctrl = this;
    angular.forEach(this.shippingCountries, function(country1) {
      if (profile.shippingCountry.countryCode === country1.label) {
        country = {
          "id": parseInt(country1.value),
          "countryCode":country1.label,
          "name": country1.name
        };
        angular.forEach(country1.states, function(state1) {
          if (profile.shippingState.code === state1.value) {
            state = {
              "id": state1.id,
              "code": state1.value,
              "name": state1.label
            };
          }
        });
      }
    });
    this.temp.shippingCountry=country;
    this.temp.shippingState=state;
    // Validating PO Box character in address 
    if(this.$auth.validatingPoBoxAddress(this.profile.store.postboxAddress,this.temp.shippingAddressLine1)){ 
      // this.$toaster.pop('success','We do not deliver to PO Boxes. Please enter a street address.');
      return false;
    }

    userDetail = {
      'phoneNumber': this.temp.phoneNumber,
      'customer': {
        'firstName': null,
        'lastName': null,
        'dateOfBirth': new Date(this.profile.customer.dateOfBirth).getTime(),
        'addressLine1': null,
        'addressLine2': null,
        'city': null,
        'state': {
          'code': null
        },
        'country': null,
        'zipCode': null
      },
      'billingAddressLine1': this.profile.billingAddressLine1,
      'billingAddressLine2': this.profile.billingAddressLine2,
      'billingCity': this.profile.billingCity,
      'billingState': this.profile.billingState,
      'billingCountry': this.profile.billingCountry,
      'billingZipCode': this.profile.billingZipCode,
      'shippingAddressLine1': this.temp.shippingAddressLine1,
      'shippingAddressLine2': this.temp.shippingAddressLine2,
      'shippingCity': this.temp.shippingCity,
      'shippingState': this.temp.shippingState,
      'shippingCountry': this.temp.shippingCountry,
      'shippingZipCode': this.temp.shippingZipCode
    };
    if (!this.temp.billingState) {
      userDetail.billingState = {
        'code': null
      };
    }
    if (!this.temp.shippingState) {
      userDetail.shippingState = {
        'code': null
      };
    }
    
    this.$auth.avalaraResolveAddress(userDetail, this.profile.store)
      .then( resolveAddress => {
          console.log("ResolveAddress : ", resolveAddress);
          $ctrl.$auth.openPopUpForAddressResolve(userDetail,resolveAddress, 
            addResolved => {
              $ctrl.$spinner.hide('appSpinner');
              console.log("Call back function", addResolved);
              if(addResolved.isCanceled){
                console.log("Canceled");
              } else {
                $ctrl.temp.shippingAddressLine1 = addResolved.shippingAddressLine1;
                $ctrl.temp.shippingAddressLine2 = addResolved.shippingAddressLine2;
                $ctrl.temp.shippingCity = addResolved.shippingCity;
                $ctrl.temp.shippingState =  addResolved.shippingState;
                $ctrl.temp.shippingCountry = addResolved.shippingCountry;
                $ctrl.temp.shippingZipCode = addResolved.shippingZipCode;
                $ctrl.temp.phoneNumber = addResolved.phoneNumber;
                
                if ($ctrl.saveAddressToProfile) {
                  // If checkbox clicked, save address
                  userDetail.shippingAddressLine1 = $ctrl.temp.shippingAddressLine1;
                  userDetail.shippingAddressLine2 = $ctrl.temp.shippingAddressLine2;
                  userDetail.shippingCity = $ctrl.temp.shippingCity;
                  userDetail.shippingState = $ctrl.temp.shippingState;
                  userDetail.shippingCountry = $ctrl.temp.shippingCountry;
                  userDetail.shippingZipCode = $ctrl.temp.shippingZipCode;
                  userDetail.phoneNumber = $ctrl.temp.phoneNumber;
                  userDetail.validatedAddressType = $ctrl.profile.store.validateAddressType;
                  $ctrl.checkAndSaveAddress(userDetail, form);
              } else {
                // userDetail = this.profile;
                addResolved.validatedAddressType = $ctrl.profile.store.validateAddressType;
                userDetail.shippingAddressLine1 = $ctrl.shippingAddressTempSolution.shippingAddressLine1;
                userDetail.shippingAddressLine2 = $ctrl.shippingAddressTempSolution.shippingAddressLine2;
                userDetail.shippingCity = $ctrl.shippingAddressTempSolution.shippingCity;
                userDetail.shippingState = $ctrl.shippingAddressTempSolution.shippingState;
                userDetail.shippingCountry = $ctrl.shippingAddressTempSolution.shippingCountry;
                userDetail.shippingZipCode = $ctrl.shippingAddressTempSolution.shippingZipCode;
                userDetail.phoneNumber = $ctrl.shippingAddressTempSolution.phoneNumber;
                userDetail.validatedAddressType = $ctrl.shippingAddressTempSolution.store.validateAddressType;
                $ctrl.checkAndSaveAddress(userDetail, form);
              }
          }
        }
      ); }
      )
      .catch( err => {
        userDetail = $ctrl.profile;
        userDetail.validatedAddressType = $ctrl.profile.store.validateAddressType;
        $ctrl.checkAndSaveAddress(userDetail, form);

      });
  }

  onZipKeyUp1() {
    if (this.profile.shippingZipCode && this.profile.shippingZipCode.length > 5){
      this.mask1 = '99999-9999';
    }
    else {
      this.mask1 = '99999';
    }
  }
  goToSubscriptionDetail(){
    var subScribedInfo = this.$auth.getSubscribedInfo();
    if (subScribedInfo && subScribedInfo.addressChange){
      this.$state.go('subscription-detail', {subscriptionId: subScribedInfo.id, option: subScribedInfo.option});
    }
  }

  // avalaraResolveAddress(userDetail, store, form) {
  //   console.log("Calling Resolve address : ", userDetail);
  //   // if(store.validateAddressType !== 'NOT_VALIDATE' && store.validateAddressType != this.detail.validatedAddressType){
  //       userDetail.store = store;
  //       this.$auth.avalaraResolveAddress(userDetail, store)
  //       .then( success => {
  //           console.log("Success validating : ", success);
  //           var $ctrl = this;
  //           $ctrl.userDetail = userDetail;
  //           $ctrl.success = success;
  //           var modalInstance;
  //           if(success.data){
  //             modalInstance = this.$uibModal.open({
  //               size: 'md',
  //               template: '<div class="modal-header modalheaderbg btn-primary"><h5>Resolve Shipping Address</h5></div>' +
  //                 '<div class="modal-body" id="modal-body">' +
  //                 '<div class="container-fluid">' +
  //                 '<div class="col-md-12 error-text" ng-if="error.message">{{error.message}}</div>' +
  //                 '<div class="row">' +
          
  //                 `<div class="col-md-12">
  //                       <div class="col-md-12 mb-4" style="text-align: center;">
  //                         <h6><strong>From</strong></h6>
  //                       </div>
    
    
  //                       <div class="col-md-12">
  //                       <div class="col-md-5">
  //                         <label style="color: #b58150;font-weight: bold;">Address Line 1</label>
  //                       </div>
  //                       <div class="col-md-7">
  //                         {{(user.shippingAddressLine1 ? user.shippingAddressLine1.trim() : '')}}
  //                       </div>
  //                       </div>
    
  //                       <div class="col-md-12">
  //                       <div class="col-md-5">
  //                         <label style="color: #b58150;font-weight: bold;">Address Line 2</label>
  //                       </div>
  //                       <div class="col-md-7">
  //                         {{(user.shippingAddressLine2 ? user.shippingAddressLine2.trim() : '')}}
  //                       </div>
  //                       </div>
    
  //                       <div class="col-md-12">
  //                       <div class="col-md-5">
  //                         <label style="color: #b58150;font-weight: bold;">City</label>
  //                       </div>
  //                       <div class="col-md-7">
  //                         {{(user.shippingCity ? user.shippingCity.trim() : '')}}
  //                       </div>
  //                       </div>
    
    
  //                       <div class="col-md-12">
  //                       <div class="col-md-5">
  //                         <label style="color: #b58150;font-weight: bold;">State</label>
  //                       </div>
  //                       <div class="col-md-7">
  //                         {{(user.shippingState ? user.shippingState.code : '')}}
  //                       </div>
  //                       </div>
    
    
  //                       <div class="col-md-12">
  //                       <div class="col-md-5">
  //                         <label style="color: #b58150;font-weight: bold;">Zip</label>
  //                       </div>
  //                       <div class="col-md-7">
  //                         {{(user.shippingZipCode ? user.shippingZipCode.trim() : '')}}
  //                       </div>
  //                       </div>
    
  //                 </div>`
  //                 +
                  
  //                 `<div ng-if="isValidAddress">
  //                 <br>
  //                 <div class="col-md-12">
  //                 <div class="col-md-12 mb-4" style="text-align: center;">
  //                   <h6><strong>To</strong></h6>
  //                 </div>
    
    
  //                 <div class="col-md-12">
  //                 <div class="col-md-5">
  //                   <label style="color: #b58150;font-weight: bold;">Address Line 1</label>
  //                 </div>
  //                 <div class="col-md-7">
  //                   {{(selected.addressLine1 ? selected.addressLine1.trim() : '')}}
  //                 </div>
  //                 </div>
    
  //                 <div class="col-md-12">
  //                 <div class="col-md-5">
  //                   <label style="color: #b58150;font-weight: bold;">Address Line 2</label>
  //                 </div>
  //                 <div class="col-md-7">
  //                   {{(selected.addressLine2 ? selected.addressLine2.trim() : '')}}
  //                 </div>
  //                 </div>
    
  //                 <div class="col-md-12">
  //                 <div class="col-md-5">
  //                   <label style="color: #b58150;font-weight: bold;">City</label>
  //                 </div>
  //                 <div class="col-md-7">
  //                   {{(selected.city ? selected.city.trim() : '')}}
  //                 </div>
  //                 </div>
    
    
  //                 <div class="col-md-12">
  //                 <div class="col-md-5">
  //                   <label style="color: #b58150;font-weight: bold;">State</label>
  //                 </div>
  //                 <div class="col-md-7">
  //                   {{(selected.state ? selected.state.code : '')}}
  //                 </div>
  //                 </div>
    
    
  //                 <div class="col-md-12">
  //                 <div class="col-md-5">
  //                   <label style="color: #b58150;font-weight: bold;">Zip</label>
  //                 </div>
  //                 <div class="col-md-7">
  //                   {{(selected.zip ? selected.zip.trim() : '')}}
  //                 </div>
  //                 </div>
  //                 </div>
  //                 </div>

  //                 <div class="col-md-12" ng-if="!isValidAddress">
  //                 <br>
  //                 <div class="col-md-5">
  //                   <label style="color: #b58150;font-weight: bold;">Given Address not Validated with our records</label>
  //                 </div>
  //                 <div class="col-md-7">
  //                   {{summary}}
  //                 </div>
  //                 </div>
  //                 ` +

  //                 '</div>' +
  //                 '</div>' +
  //                 '<div class="modal-footer">' +
  //                 '<button  ng-if="isValidAddress" class="btn btn-primary m-l-1" type="button" ng-click="submit()" style="float: right;">Update</button>' +
  //                 '<button  ng-if="!isValidAddress" class="btn" type="button m-l-1" ng-click="back()" style="float: left;">Use this address anyway</button>' +
  //                 '<button  ng-if="!isValidAddress" class="btn" type="button m-l-1" ng-click="fix()" style="float: right;">I will fix the address</button>' +
                  
  //                 '</div>',
  //             controller: ['$scope', '$state', '$uibModalInstance',
  //               function ($scope, $state, $uibModalInstance) {
  //                 $scope.error = { message: '' };
  //                 $scope.user = $ctrl.userDetail;
  //                 $scope.isValidAddress = false;
  //                 $scope.count = 1;
  //                 if($ctrl.userDetail.store.validateAddressType==='BOTH_BILL_SHIP'){
  //                   $scope.count = 2;
  //                 }
  //                 if($ctrl.success.data.resolutionQuality==='Intersection') {
  //                   $scope.isValidAddress = true;
  //                   if($ctrl.userDetail.store.validateAddressType === 'Shipping'){
  //                     $scope.selected = $ctrl.success.data.shippingAddresstoResolve;
  //                   }
  //                   else if ($ctrl.userDetail.store.validateAddressType === 'Billing'){
  //                     $scope.selected = $ctrl.success.data.billingAddresstoResolve;
  //                   }
  //                 } else {
  //                   if($ctrl.userDetail.store.validateAddressType === 'Shipping'){
  //                     $scope.invalidDetails = $ctrl.success.data.shippingAddresstoResolve.details;
  //                     $scope.summary  = $ctrl.success.data.shippingAddresstoResolve.summary;
  //                   }
  //                   else if ($ctrl.userDetail.store.validateAddressType === 'Billing'){
  //                     $scope.invalidDetails = $ctrl.success.data.billingAddresstoResolve.details;
  //                     $scope.summary  = $ctrl.success.data.billingAddresstoResolve.summary;
  //                   }
  //                 }
  //                 $scope.submit = () => {
  //                   // $ctrl.$spinner.show('appSpinner');
  //                   console.log("It calls from submit");
  //                   $scope.user.validatedAddressType = $ctrl.userDetail.store.validateAddressType;
  //                   $scope.user.shippingAddressLine1 = $scope.selected.addressLine1;
  //                   // $scope.user.shippingAddressLine2 = $scope.selected.addressLine1;
  //                   $scope.user.shippingCity = $scope.selected.city;
  //                   $scope.user.shippingState.code = $scope.selected.state.code;
  //                   $scope.user.shippingCountry.code = $scope.selected.country.code;
  //                   $scope.user.shippingZipCode = $scope.selected.zip;
  //                   $uibModalInstance.close($scope.user);
  //                 };
  //                 $scope.cancel = () => $uibModalInstance.dismiss('cancel');
  //                 $scope.back = () => {
  //                   $scope.user.validatedAddressType = $ctrl.userDetail.store.validateAddressType;
  //                   $uibModalInstance.close($scope.user);
  //                 };
  //                 $scope.fix = () => {
  //                   console.log("In fixing ");
  //                   // $ctrl.$state.go('profile.edit');
  //                   // $uibModalInstance.close($scope.user);
  //                 };
  //               }
  //             ],
  //             resolve: {
  //             }
  //           });
  //           modalInstance.result.then(function (data) {
  //               console.log('user clicked ok', data);
  //               $ctrl.checkAndSaveAddress(data, form);
  //           });
  //         }
  //       })
  //       .catch( error => {
  //         console.log("Didn't call service resolve address : ", error);
  //       });
  //   }


    checkAndSaveAddress(userDetail, form){
      // if (this.saveAddressToProfile) {
            form.error = {};
            localStorage.setItem('deliveryAddress', JSON.stringify(this.temp));
            this.$auth.updateUserProfile(userDetail, this.profile.userId)
              .then(() => {
              var subScribedInfo = this.$auth.getSubscribedInfo();
            if (subScribedInfo && subScribedInfo.addressChange){
              this.$state.go('subscription-detail', {subscriptionId: subScribedInfo.id, option: subScribedInfo.option});
            }
            else {
              this.$state.go('delivery');
            }
        })
        .catch(err => form.error = err.data);
      // }
      // else {
      //   localStorage.setItem('deliveryAddress', JSON.stringify(this.temp));
      //   var subScribedInfo = this.$auth.getSubscribedInfo();
      //   if (subScribedInfo && subScribedInfo.addressChange){
      //     this.$state.go('subscription-detail', {subscriptionId: subScribedInfo.id, option: subScribedInfo.option});
      //   }
      //   else {
      //     this.$state.go('delivery');
      //   }
      // }
    }

 }




// WEBPACK FOOTER //
// ./src/app/order/delivery/address.js